<template>
    <div>
        <div class="row-custom">
            <div class="top-header">
                <div class="level">
                    <div class="level-left">
                        Backstage │ 日本最大級のエンタメ特化のマッチングプラットフォーム
                    </div>
                    <div class="level-right">
                        <a href="#">サイトマップ</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row-custom">
            <!--header-->
            <div class="header">
                <div class="container">
                    <div class="level">
                        <div class="level-left">
                            <div class="logo">
                                <a href="/">
                                    <img :src="require('@/assets/img/logo-home.png')" alt/>
                                </a>
                            </div>
                        </div>
                        <div class="level-right">
                            <ul class="btns btn-header-main display-none-navbar">
                                <!-- 暫定処理 後で復活予定 -->
                                <li class="contentClient"><a href="/company/register/project" class="btnEffect">案件を投稿</a></li>                                
                                <li class="contentClient login"><a href="/company/login" class="btnEffect btn-login-index">ログイン</a></li>
                                <!-- <li class="contentClient"><a href="https://forms.gle/vqFiKuZUDW9qb6bA6" target="_blank" class="btnEffect">案件を投稿</a></li>
                                <li class="contentClient login"><a href="https://forms.gle/vqFiKuZUDW9qb6bA6" target="_blank" class="btnEffect btn-login-index">ログイン<font size="1">(事前登録受付中)</font></a></li> -->
                                <li class="contentArtisan show"><a href="/search/public/project" class="btnEffect">案件を検索</a></li>
                                <li class="contentArtisan login show"><a href="/worker/login" class="btnEffect btn-login-worker-index">ログイン</a></li>
                            </ul>
                            <a href="/company/register" class="btn btn-intro-box" style="position: absolute; right: 0px; top: 80px">
                                <p>職人の方 ： 登録先着 <span style="color: yellow;">1,000名</span>様へ</p>
                                <p style="display: inline;">アマゾンギフト 3,000円分進呈</p>                                        
                            </a>
                            <ul class="btns btn-header-main display-none-web nav-mobile-manager">
                                <li class="contentClient"><a href="#" class="btnEffect" @click="changeWorker">働きたい方</a>
                                    <span @click="changeWorker" class="icon-change">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                                             viewBox="0 0 320 320">
                                        <path fill="%23fff"
                                              d="M159.5,319.5c-88.224,0-160-71.775-160-160c0-88.224,71.776-160,154-160c88.225,0,160,71.776,160,160C319.5,247.725,247.725,319.5,159.5,319.5zM159.5,19.5c-77.196,0-140,62.804-140,140s62.804,140,140,140s140-62.804,140-140S236.696,19.5,159.5,19.5z"/>
                                        <path fill="%23fff"
                                              d="M233.161,85.852c-13.741-13.741-31.321-23.682-51.021-28.03l1.352-25.8l-50.909,26.824l-13.597,7.197l-2.523,1.322l4.021,2.157l19.002,10.229l40.349,21.712l1.135-21.342c14.074,3.758,26.609,11.219,36.661,21.232c14.909,14.908,24.081,35.415,24.081,58.15c0,11.656-2.412,22.697-6.761,32.709l20.103,8.73c5.516-12.68,8.586-26.71,8.586-41.44C263.68,130.771,251.985,104.676,233.161,85.852z"/>
                                        <path fill="%23fff"
                                              d="M179.546,239.25l-40.385-21.718l-1.131,21.347c-14.072-3.762-26.646-11.219-36.659-21.23c-14.912-14.914-24.083-35.416-24.083-58.146c0-11.666,2.412-22.668,6.76-32.715l-20.103-8.729c-5.516,12.713-8.586,26.752-8.586,41.444c0,28.722,11.656,54.854,30.48,73.646c13.741,13.74,31.321,23.677,51.018,27.986l-1.352,25.844l50.876-26.829l13.672-7.197l2.483-1.316l-3.983-2.157L179.546,239.25z"/>
                                    </svg>
                                    </span>
                                </li>
                                <li class="contentClient login"><a href="#" class="btnEffect btn-login-index">ログイン</a></li>
                                <li class="contentArtisan show"><a href="#" class="btnEffect" @click="changeManager">依頼したい方</a>
                                    <span @click="changeManager" class="icon-change">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                                         viewBox="0 0 320 320">
                                        <path fill="%23fff"
                                              d="M159.5,319.5c-88.224,0-160-71.775-160-160c0-88.224,71.776-160,154-160c88.225,0,160,71.776,160,160C319.5,247.725,247.725,319.5,159.5,319.5zM159.5,19.5c-77.196,0-140,62.804-140,140s62.804,140,140,140s140-62.804,140-140S236.696,19.5,159.5,19.5z"/>
                                        <path fill="%23fff"
                                              d="M233.161,85.852c-13.741-13.741-31.321-23.682-51.021-28.03l1.352-25.8l-50.909,26.824l-13.597,7.197l-2.523,1.322l4.021,2.157l19.002,10.229l40.349,21.712l1.135-21.342c14.074,3.758,26.609,11.219,36.661,21.232c14.909,14.908,24.081,35.415,24.081,58.15c0,11.656-2.412,22.697-6.761,32.709l20.103,8.73c5.516-12.68,8.586-26.71,8.586-41.44C263.68,130.771,251.985,104.676,233.161,85.852z"/>
                                        <path fill="%23fff"
                                              d="M179.546,239.25l-40.385-21.718l-1.131,21.347c-14.072-3.762-26.646-11.219-36.659-21.23c-14.912-14.914-24.083-35.416-24.083-58.146c0-11.666,2.412-22.668,6.76-32.715l-20.103-8.729c-5.516,12.713-8.586,26.752-8.586,41.444c0,28.722,11.656,54.854,30.48,73.646c13.741,13.74,31.321,23.677,51.018,27.986l-1.352,25.844l50.876-26.829l13.672-7.197l2.483-1.316l-3.983-2.157L179.546,239.25z"/>
                                    </svg>
                                    </span>
                                </li>
                                <li class="contentArtisan login show"><a href="#" class="btnEffect btn-login-worker-index">ログイン</a></li>
                            </ul>
                        </div>

                    </div>
                    <menu-mobile></menu-mobile>
                </div>
            </div>
            <!--end header-->
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import jquery from 'jquery'
    import MenuMobile from "./menu-mobile";
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

    export default {
        name: 'default-layout',
        components: {MenuMobile, FontAwesomeIcon},
        comments: {
            MenuMobile
        },
        mounted() {
            jquery(document).ready(function () {
                jquery(".navbar-burger").click(function () {
                    jquery(".navbar-burger").toggleClass("is-active");
                    jquery(".navbar-menu").toggleClass("is-active");
                });
            });

            jquery(window).scroll(function () {
                var scroll = jquery(window).scrollTop();
                if (scroll >= 100) {
                    jquery(".header").addClass("animated fadeInUp menu-scroll");
                    jquery(".nav.nav-tabs").addClass("nav-tabs-scroll");
                    jquery("#mainnav").addClass("main-nav-scroll");
                    jquery("#mainnav-worker").addClass("main-nav-worker-scroll");
                } else {
                    jquery(".header").removeClass("animated fadeInUp menu-scroll");
                    jquery(".nav.nav-tabs").removeClass("nav-tabs-scroll");
                    jquery("#mainnav").removeClass("main-nav-scroll");
                    jquery("#mainnav-worker").removeClass("main-nav-worker-scroll");
                }
            });
            this.oldHtmlClass = document.documentElement.className.split(" ");
            document.documentElement.setAttribute('class', 'home-page')
        },
        methods: {
            changeWorker() {
                jquery('.home-tabs ul.nav-tabs li:first-child a').removeClass("active_tab");
                jquery('.home-tabs ul.nav-tabs li:nth-child(2) a').addClass("active_tab");
                jquery('.home-tabs ul.nav-tabs li:nth-child(2)').trigger("click");

                jquery('#navTabSub li:first-child span').removeClass("active");
                jquery('#navTabSub li:nth-child(2) span').addClass("active");

                jquery('.home-page-worker li.aos-init').removeClass("aos-animate");
                jquery('.home-page-worker .secPoint li').removeClass("aos-animate");
                jquery('.home-page-worker .secIntroArtisan li').removeClass("aos-animate");
                jquery('.home-page-worker .secRec li').removeClass("aos-animate");
                jquery('.home-page-worker .secCat li').removeClass("aos-animate");
                jquery('.home-page-worker .secFlow li').removeClass("aos-animate");
                jquery('.home-page-worker .secFaq li').removeClass("aos-animate");
                jquery('.step2-3').removeClass("aos-animate");
            },
            changeManager() {
                jquery('.home-tabs ul.nav-tabs li:nth-child(2) a').removeClass("active_tab");
                jquery('.home-tabs ul.nav-tabs li:first-child a').addClass("active_tab");
                jquery('.home-tabs ul.nav-tabs li:first-child').trigger("click");

                jquery('#navTabSub li:nth-child(2) span').removeClass("active");
                jquery('#navTabSub li:first-child span').addClass("active");
            },
        }
    }
</script>

<!-- Google tag (gtag.js) 　-->
<!-- 
<script async src="https://www.googletagmanager.com/gtag/js?id=G-QLPFC3FR3V"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-QLPFC3FR3V');
</script>　-->

<style scoped>
.btn-intro-box {    
    width: 238px;
    height: 35px;
    background-color: red !important;
    padding: 0px !important;
    font-size: 0.9rem !important;
    line-height: 1.0rem !important;
    border-radius: 3px !important;
    color: white !important;
    &-free {        
        padding-top: 0;
        padding-bottom: 0;
        font-size: 1.2rem;
        line-height: 1.2rem;
        height: 1.2rem;
        color: yellow; 
        >svg {
            position: absolute;
            top: 1px;
            margin-left: 6px;
            display: inline-block;
            height: 20px;
        }       
    }
}

.small-message {
    font-size: 0.8rem;
    color: white;
}
</style>
